import {useEffect,useState} from 'react';
import {traderAPI,useTraderAuth} from '../context/TraderAuthContext';
import {watchLiveRefresh} from '../../hooks/liveRefresh';
export const useWithdrawalData=(path,version=0)=>{
  const {user}=useTraderAuth(),key=`${user?.id}:${path}`,[state,setState]=useState({key:null,loading:true,data:null,error:''});
  useEffect(()=>{
    let live=true,pending=false;const controller=new AbortController();
    setState({key,loading:Boolean(path),data:null,error:''});
    if(!path)return()=>controller.abort();
    const refresh=async()=>{if(pending)return;pending=true;try{const {data}=await traderAPI.get(path,{signal:controller.signal,timeout:20000});if(live)setState({key,loading:false,data,error:''});}catch(e){if(live)setState({key,loading:false,data:null,error:typeof e.response?.data?.detail==='string'?e.response.data.detail:'Account information could not be refreshed.'});}finally{pending=false;}};
    refresh();const stop=watchLiveRefresh(refresh,5000);
    return()=>{live=false;stop();controller.abort();};
  },[path,key,version]);
  return state.key===key?state:{loading:true,data:null,error:''};
};